// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const blipbug: PokeData = {
  "id": 824,
  "name": "blipbug",
  "height": 4,
  "weight": 80,
  "base_experience": 36,
  "types": [
    PokeType.BUG
  ],
  "api_moves": [
    "struggle-bug"
  ],
  "moves": [
    "pounce",
    "bug-buzz",
    "string-shot",
    "heal-order",
    "bug-bite",
    "leech-steal",
    "lunge",
    "pin-missile",
    "pin-rush",
    "signal-spam",
    "sticky-web",
    "infest"
  ],
  "evolution_chain": {
    "id": 435,
    "item": null,
    "species": [
      {
        "name": "blipbug",
        "order": 824,
        "types": [
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dottler",
        "order": 825,
        "types": [
          PokeType.BUG,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 824,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 10,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "orbeetle",
        "order": 826,
        "types": [
          PokeType.BUG,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 825,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 28.75,
    "speed": 45,
    "ability_power": 25
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
